import './display.css'

// Top bar of a display window. Pass a `title` for the simple case (with optional
// `actions` on the right), or `children` for fully custom header content.
function DisplayHeader({ title, actions, children }) {
  return (
    <div className="display-header">
      {children != null ? (
        children
      ) : (
        <span className="display-header-title">{title}</span>
      )}
      {actions != null && <div className="display-header-actions">{actions}</div>}
    </div>
  )
}

export default DisplayHeader
